import React from 'react';

import type { ExtensionHandlers } from '@atlaskit/editor-common/extensions/extension-handler';
import type { ExtensionManifest } from '@atlaskit/editor-common/extensions/extension-manifest';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightTarget } from '@atlaskit/onboarding';

import { RedactionMarker } from './ui/redaction-marker';

const EXTENSION_TYPE = 'com.atlassian.guard-premium';

export const getRedactionExtensionHandler: (
	getSpotlightKey?: () => string | null,
) => ExtensionHandlers = (getSpotlightKey) => ({
	[EXTENSION_TYPE]: () => {
		if (getSpotlightKey) {
			const key = getSpotlightKey();
			return (
				<SpotlightTarget name={`redaction-marker-${key}`}>
					<RedactionMarker />
				</SpotlightTarget>
			);
		}
		return <RedactionMarker />;
	},
});

export const getRedactionExtension: () => ExtensionManifest = () => {
	return {
		title: 'Redaction',
		type: EXTENSION_TYPE,
		key: 'redaction',
		description: 'Inserts redacted block.',
		icons: {
			'48': () => import('@atlaskit/icon-lab/core/browser-extension'),
		},
		modules: {
			nodes: {
				default: {
					type: 'inlineExtension',
					render: async () => RedactionMarker,
					// Redacted content must not be copyable; hide the copy button
					// from the selection toolbar (delete-only).
					hideCopyButton: true,
				},
			},
		},
	};
};
